import Reflux from 'reflux';
import ShowData from 'shared/data/Show';

let async = { asyncResult: true },
  GlobalElementSetEditFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    save: async,
    populate: {},
    cancel: {},
  });

GlobalElementSetEditFormActions.save.listenAndPromise(
  ShowData.updateGlobalElementContainer,
);

export default GlobalElementSetEditFormActions;
